// extracted by mini-css-extract-plugin
export default {"head-skeleton__title":"styles_head-skeleton__title__Dkq3f","head-skeleton__action--wrapper":"styles_head-skeleton__action--wrapper__T86Cq"};